export enum PasswordComplexity {
  TOO_SHORT = 1,
  NO_LOWERCASE_CHARACTER = 2,
  NO_UPPERCASE_CHARACTER = 3,
  NO_NUMERIC_CHARACTER = 4,
  NO_SPECIAL_CHARACTER = 5,
}
